import React from 'react';
import PropTypes from 'prop-types';
import raychemBlack from 'src/assets/raychem-smarttrace-black.svg';

export default function LogoSpinner (props) {
  const {
    size,
    thickness,
    square
  } = props;

  return square ? (
    <svg data-testid='logo' className='st-logo-sq' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' viewBox='0 0 154.78 154.78' shapeRendering='geometricPrecision' width={size} height={size}>
      <g className='st-logo-sq-container'>
        <path className='st-logo-sq-line' d="M 149.70246,149.71238 149.70497,14.526227 86.41,95.12 67.93,80.39 10.644036,149.72057 Z" fill='none' stroke='#000' strokeWidth={thickness} strokeMiterlimit={thickness} />
      </g>
    </svg>
  ) : (
    <img data-testid='logo' src={raychemBlack} width={size} alt='Raychem SmartTrace' />
  );
}

LogoSpinner.propTypes = {
  size: PropTypes.number.isRequired,
  thickness: PropTypes.number,
  square: PropTypes.bool
};

LogoSpinner.defaultProps = {
  thickness: 8,
  square: false
};
